import { gql } from '@apollo/client';

// https://dev-dealer-graphql.apps.emea.vwapps.io/

export const GET_DEALER = gql`
  query dealerById($dealerId: String!) {
    dealerById(dealerId: $dealerId) {
      name
      kvpsId
      city
      region
    }
  }
`;
